import { render, staticRenderFns } from "./BookingsRequests.vue?vue&type=template&id=095868ac&"
import script from "./BookingsRequests.vue?vue&type=script&lang=js&"
export * from "./BookingsRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports